import { useState, useEffect, useRef } from 'react';

export const useDebounce = (value, delay) => {
  const [debouncedValue, setDebouncedValue] = useState(value);

  useEffect(() => {
    const handler = setTimeout(() => {
      setDebouncedValue(value);
    }, delay);

    return () => {
      clearTimeout(handler);
    };
  }, [value, delay]);

  return debouncedValue;
};

export function usePrevious(value) {
  const ref = useRef();
  useEffect(() => {
    ref.current = value;
  });
  return ref.current;
}

export const WithUpdateCondition = ({ condition, setShouldRender }) => {
  useEffect(() => {
    if (condition) {
      setShouldRender(false);
      setTimeout(() => setShouldRender(true), 100);
    }
    // eslint-disable-next-line
  }, [condition]);
};
